import 'material-design-icons-iconfont/dist/material-design-icons.css';
import './styles/variables.scss';

import CKEditor from '@ckeditor/ckeditor5-vue2';
import { Integrations } from "@sentry/tracing";
import * as Sentry from "@sentry/vue";
import Vue from 'vue';
import VueGtag from 'vue-gtag';

import App from './App.vue';
import mixins from './mixins/mixins';
import appAuth from './plugins/auth';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store/store';

Vue.config.productionTip = false;
Vue.use(CKEditor);
Vue.use(VueGtag, {
    config: {
        id: process.env.VUE_APP_GTAG_CONFIG_ID,
    },
    includes: [
        {
            id: process.env.VUE_APP_GTAG_APP_ID,//'G-HX79RPD877',
        }],
    appName: process.env.VUE_APP_NAME,
    pageTrackerScreenviewEnabled: true,

}, router);

Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    logErrors: true
});

let app = '';

appAuth.onAuthStateChanged(() => {
    if (!app) {
        app = new Vue({
            router,
            store,
            vuetify,
            mixins: [mixins],
            render: h => h(App),
        }).$mount('#app');
    }
});
